<template>
  <div class="logoWrapper">
    <div v-if="logo" class="innerlogo">
      <img class="image" :src="logo" />
      <h3 class="contactName" v-if="!clientMode">Welcome {{userData.introducerContactName}}</h3>
    </div>
    <span v-else>
      <h3 class="contactName">{{userData.introducerName}}</h3>
      <h2 v-if="!clientMode">Welcome {{userData.introducerContactName}}</h2>
    </span>
    <div class="logoUnderline"></div>
  </div>
</template>

<script>
export default {
  computed: {
    logo: function() {
      return this.$store.state.logo;
    },
    userData: function() {
      if (!this.$store.state.userData) {
        return {}
      }
      let dat = this.$store.state.userData;
      let ret = {
        introducerName: dat.Name
      }
      if (dat.contactName) {
        ret.introducerContactName = dat.contactName
      }
      return ret
    },
    clientMode: function() {
      return this.$store.state.clientMode;
    }
  }
};
</script>
<style lang="scss" scoped>
.logoWrapper {
  width: 100%;
  margin-top: 50px;
  transition: none;
  @media (max-height: 700px) {
    margin-top: 10px;
  }
}
.innerlogo {
  height: inherit;
  transition: none;
}
.image {
  height: 13vh;
  width: 90%;
  object-fit: contain;
  transition: none;
}
.contactName {
  margin: 0px;
  padding: 10px;
}
.logoUnderline {
  width: 100%;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(100, 100, 100, 0),
    rgba(255, 255, 255, 1),
    rgba(100, 100, 100, 0)
  );
  margin-top: 5px;
  box-shadow: 0 -20px 20px white;
}
</style>